import {
  FETCH_VENDORS_SUCCESS, ADD_VENDOR, EDIT_VENDOR
} from '../actions/vendorActions.js';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_VENDORS_SUCCESS:
      return action.vendors;
    case EDIT_VENDOR:
      return state.map((vendor) => {
        if (vendor.id === action.id) {
          return {
            ...vendor,
            ...action.updates
          };
        }
        return vendor;
      });
    case ADD_VENDOR:
      return [
        ...state, action.vendor
      ];
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/vendorsReducer.js